import type { ReactNode } from 'react';

export interface HeaderProps {
  /** Content for the left side (typically breadcrumbs or a page title). */
  left: ReactNode;
  /** Content for the right side (search trigger, theme toggle, user menu, etc). */
  right: ReactNode;
}

/**
 * Structural header primitive. Sticky, glass background, hairline border.
 * Apps build their own left/right clusters and pass them in.
 */
export function Header({ left, right }: HeaderProps) {
  return (
    <header
      className="sticky top-0 z-30 flex h-14 items-center justify-between border-b px-6 backdrop-blur-md"
      style={{
        background: 'var(--bg-glass)',
        borderColor: 'var(--border-line)',
      }}
    >
      <div className="flex min-w-0 items-center gap-1.5">{left}</div>
      <div className="flex items-center gap-2">{right}</div>
    </header>
  );
}
